import { Container, Modal, Nav } from 'react-bootstrap'
import { Pagination } from '@mui/material'
import { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'
import AuctionCard from '../components/auction/AuctionCard'
import FooterNew from '../components/Footer'
import Navigation from '../components/Navigation'
import { useStore } from '../../app/stores/store'
import { FilterModes, PopUpMode } from '../../app/models/modes'
import ComponentLoader from '../components/loaders/ComponentLoader'
import AuctionPopUp from './AuctionPopUp'

function AuctionList() {
  const { auctionListStore, methodsStore } = useStore()
  const { showCreateAuction, setShowCreateAuction } = methodsStore
  const { auctions } = auctionListStore
  const [loadingInitial, setLoadingInitial] = useState(true)
  const [page, setPage] = useState(1)
  const paginateAuctions = 9
  const { t } = useTranslation()

  useEffect(() => {
    auctionListStore.loadAuctions().finally(() => setLoadingInitial(false))
  }, [auctionListStore])

  function paginate(array: any) {
    return array.slice((page - 1) * paginateAuctions, page * paginateAuctions)
  }

  // function handlePurchase() {
  //   history.push('/services')
  // }

  if (loadingInitial) return <ComponentLoader mTop={100} />

  return (
    <>
      <Navigation type={FilterModes.auction} />

      <Container fluid className='auction-container'>
        <div className='d-flex justify-content-center mt-3'>
          <Nav.Link>
            <button
              className='add-auction-btn'
              onClick={() => methodsStore.setShowCreateAuction(true)}
            >
              <i className='fa-solid fa-plus' /> {t('add_auction')}
            </button>
          </Nav.Link>
        </div>
        <div className='auction-content'>
          {/* {userStore.isLoggedIn && (
            <Card className='newFont free-plan card-shadow mb-5 mt-3'>
              <div className='free-plan-padding'>
                <p>
                  {t('auctions_left')}:
                  <strong className='ps-2'>{userStore.user?.auctionUse}</strong>
                </p>
                <p>
                  {t('get_more_auctions')}:
                  <button onClick={handlePurchase} className='upgrade-button'>
                    {t('purchase')}
                  </button>
                </p>
              </div>
            </Card>
          )} */}
          {auctions.length === 0 && <h3 className='mt-5 text-center'>{t('no_auctions')}</h3>}
          <div className='auction-list mb-5'>
            {paginate(
              auctions.map((auction, index) => <AuctionCard key={index} auction={auction} />),
            )}
          </div>
          {auctions.length > 0 && (
            <Pagination
              color='primary'
              className='auctions-pagination mb-5'
              sx={{
                width: '100%',
                '& .MuiPaginationItem-root.Mui-selected, .MuiPaginationItem-root.Mui-selected:hover':
                  {
                    backgroundColor: '#4f7f71',
                  },
              }}
              page={page}
              size='large'
              onChange={(e, value) => setPage(value)}
              count={Math.ceil(auctions.length / paginateAuctions)}
            />
          )}
        </div>
      </Container>
      <FooterNew />

      {/* Auction Create Modal */}
      <Modal size='lg' centered show={showCreateAuction} onHide={() => setShowCreateAuction(false)}>
        <AuctionPopUp handleClose={() => setShowCreateAuction(false)} auctionPopUpMode={PopUpMode.Create} />
      </Modal>
    </>
  )
}
export default observer(AuctionList)
